import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Background from "../../components/Background/Background";
import ScreenNavbar from "../../components/ScreenNavbar/ScreenNavbar";
import { ConfigState } from "../../context/ConfigContext";
import { SDKInstanceState } from "../../context/SdkInstanceContext";
import { SDKParamsState } from "../../context/SdkParmasContext";
import { WorkPlatformDetailsState } from "../../context/WorkPlatformDetailsContext";
import { LoaderWithStatusState } from "../../context/LoaderWithStatusContext";
import { LoaderState } from "../../context/LoaderContext";
import Loader from "../../components/Loader/Loader";
import LoaderWithStatus from "../../components/LoaderWithStatus/LoaderWithStatus";
import { isEmpty } from "../../utils/sdk_utils";
import { SOMETHING_WENT_WRONG, STATUS_CONNECTED, STATUS_FAILED, THIRD_PARTY_OTP_STEP2 } from "../../constants/URLConstants";
import chatScreenshot from "../../assets/images/insta_dm_gif.gif";
import "./ThirdPartyOTPStep2.scss";

function ThirdPartyOTPStep2() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { configuration } = ConfigState();
  const { sdkInstance } = SDKInstanceState();
  const { sdkParams } = SDKParamsState();
  const { workplatformDetails } = WorkPlatformDetailsState();
  const { loaderWithStatus } = LoaderWithStatusState();
  const { loader, dispatchLoaderContext } = LoaderState();
  const { isConnectLoader } = LoaderWithStatusState();
  const [loaderMsgConfig, setLoaderMsgConfig] = useState({});
  
  const [platformDetail, setPlatformDetail] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [startPolling, setStartPolling] = useState(false)
  const [verificationCode, setVerificationCode] = useState();
  const [authorisationId, setAuthorisationId] = useState();
  const [accountDetails, setAccountDetails] = useState()
  const POLLING_INTERVAL_MS = 3000; // 3 seconds
  const EXPIRY_TIMEOUT_MS = 300000; // 5 minutes
  const POLLING_START_MS = 15000 // 15 seconds
  const failureStatuses = ["FAILED", "EXPIRED", "CANCELLED"];


  useEffect(() => {
    if (!isEmpty(configuration) && !isEmpty(sdkInstance)) {
      setLoaderMsgConfig(configuration.screens.short_loader_screen || {});
      const platform = workplatformDetails[params.workplatformid];
      setPlatformDetail(platform || {});
    }
  }, [configuration, sdkInstance, params.workplatformid, workplatformDetails]);

  useEffect(() => {
   if (location.state ) {
      setVerificationCode(location.state?.otp)
      setAuthorisationId(location.state?.authId)
      dispatchLoaderContext(false)
   }
  },[])

  useEffect(() => {
    if (location.state && location.state.codeCopied) {
      setShowToast(true);
      const timer = setTimeout(() => setShowToast(false), 3000);
      return () => clearTimeout(timer);
    }
    
  }, [location.state]);

  const goBack = () => {
    navigate(-1);
  };

  const openInstagram = () => {
    window.open("https://ig.me/m/phylloauth", "_blank");
    setStartPolling(true)
    dispatchLoaderContext(true)
  };

  useEffect(() => {
    let pollInterval = null;
    let expiryTimeout = null;
    let startDelayTimeout = null;
    let isPollingActive = false;

    // Helper to clear all timers
    const clearAllTimers = () => {
      if (pollInterval) clearInterval(pollInterval);
      if (expiryTimeout) clearTimeout(expiryTimeout);
      if (startDelayTimeout) clearTimeout(startDelayTimeout);
    };

    // Polling function wrapper
    const pollConnectionStatus = async () => {
      try {
        const response = await sdkInstance.getAuthorizationInfo(authorisationId || params.authid);
        if (!response || Object.keys(response).length === 0) {
          clearAllTimers();
          navigate(`${SOMETHING_WENT_WRONG}`);
          return;
        }
        if (response.status === "SUCCESS") {
          clearAllTimers();
          if (response.account_ids) {
            navigate(`/${STATUS_CONNECTED}/${response.account_ids}`);
          } else {
            navigate(`/${SOMETHING_WENT_WRONG}`);
          }
          dispatchLoaderContext(false);
          setAccountDetails(response);
        } else if (
          failureStatuses.includes(response.status)
        ) {
          clearAllTimers();
          navigate(`/${STATUS_FAILED}/${authorisationId || params.authid}`);
        }
        // else if IN_PROGRESS, do nothing, let polling continue
      } catch (err) {
        clearAllTimers();
        console.log(err);
        navigate(`${SOMETHING_WENT_WRONG}`);
      }
    };

    if (startPolling) {
      // Start polling after 15 seconds
      startDelayTimeout = setTimeout(() => {
        // Set expiry timeout for 5 minutes (300000 ms)
        expiryTimeout = setTimeout(() => {
          clearAllTimers();
          // After 5 minutes, navigate to failure state
          navigate(`/${STATUS_FAILED}/${authorisationId || params.authid}`);
        }, EXPIRY_TIMEOUT_MS);

       
        isPollingActive = true;
        pollConnectionStatus(); // Initial call
        pollInterval = setInterval(() => {
          pollConnectionStatus();
        }, POLLING_INTERVAL_MS);
      }, POLLING_START_MS);
    }

    // Cleanup on unmount or when startPolling changes
    return () => {
      clearAllTimers();
      isPollingActive = false;
    };

  }, [startPolling, authorisationId, params.authid, sdkInstance]);
  

    if (loader) {
    if (isConnectLoader && !isEmpty(loaderMsgConfig)) {
      return (
        <LoaderWithStatus
          message="Verifying your account"
          platform={platformDetail.name}
          showPopupMsg={false}
          customMessage="We’ve reviewing your request. This usually takes less than a minute."
        />
      );
    }
    return <Loader />;
  }


  return (
    <>
      <Background />
      <div className="row col-lg-3 col-md-12 col-sm-12 col-12 m-auto white-screen">
        <ScreenNavbar
          className=""
          backURL={-1}
          screenName={THIRD_PARTY_OTP_STEP2}
          workplatformDetails={{
            workplatformId: platformDetail?.id,
            workplatformName: platformDetail?.name,
          }}
        />
        <div className="otp-step2-main-container">
          {showToast && (
            <div className="otp-step2-toast">&#10003; Code copied</div>
          )}
          <div className="otp-step1-header-row">
            <span className="otp-step1-step">STEP 2 of 2</span>
          </div>
          <div className="otp-step2-instructions">
            <b>Send the code on Instagram</b>
            <div className="otp-step2-sub">
              Tap Open Instagram to start a chat with{' '}
              <a
                href="https://ig.me/m/phylloauth"
                target="_blank"
                rel="noopener noreferrer"
                className="otp-step2-link"
                onClick={openInstagram}
              >
                @phylloauth
              </a>.
              Paste the code and send it from the account you are connecting.
            </div>
          </div>
          <div className="otp-step2-chat-img-container">
            <img src={chatScreenshot} alt="Instagram chat screenshot" className="otp-step2-chat-img" />
          </div>
          <div className="row mb-12  col-12 m-auto text-center retry-button-div">
            <button className="primary-btn mb-2" onClick={openInstagram}>
              Open Instagram
            </button>
            <button
              className="secondary-btn"
              onClick={goBack}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default ThirdPartyOTPStep2; 
